import React, {useState, useEffect} from 'react'
import "./Testimonials.css"
import Sdata from './Sdata'


const Testimonials = () => {
  const [currentUser,setCurrentUser] = useState(Sdata[0]);
  const [currentIndex,setCurrentIndex] = useState(0);



  const handleClickOnNextPrevButton = (buttonType) =>{
    if(buttonType === 'prev'){
      let indexUser = currentIndex - 1;
      if(indexUser < 0){
        indexUser = Sdata.length - 1;
      }
      setCurrentUser(Sdata[indexUser]);
      setCurrentIndex(indexUser);

    }else if(buttonType === 'next'){
      let indexUser = currentIndex + 1;
      if(indexUser > Sdata.length - 1){
        indexUser = 0;
      }
      setCurrentUser(Sdata[indexUser])
      setCurrentIndex(indexUser);
    }

  }

  const handdleImageClick = (id) => {
    Sdata.forEach((user,index)=>{
      if(id === user.id){
        setCurrentUser(user);
        setCurrentIndex(index);
      }
    })
  }
  return (
    <>        
        <section className='section-2'>
          <div className='heading'>   

              <h2 className='first-content-text'>
              <span className="primary-text">Thousands </span>
              <span className="white-text">of lives changed</span>
              </h2>
              <h2 className="sub-heading">Hear it from the ones who have been on this journey already</h2>
          </div>

          <div className='student-left'>
              <div className='st-first-row'>
                <img src="https://images.geekster.in/placed/Vamsi-Krishna.webp" alt='images' className='profile-img' id='num_0' onClick={()=>{handdleImageClick('num_0')}}></img>
                <img src="https://images.geekster.in/placed/Ashwini-Kumar.webp" alt='images' className='profile-img' id='num_1' onClick={()=>{handdleImageClick('num_1')}}></img>
              </div>
              <div className='st-second-row'>
              <img src="https://images.geekster.in/placed/Anurag-Ojha.webp" alt='images' className='profile-img' id='num_2' onClick={()=>{handdleImageClick('num_2')}}></img>
              </div>
              <div className='st-third-row'>
              <img src="https://images.geekster.in/placed/Utkarsh-Singh.webp" alt='images' className='profile-img' id='num_3' onClick={()=>{handdleImageClick('num_3')}}></img>
              <img src="https://images.geekster.in/placed/Rohit-Kumar.webp" alt='images' className='profile-img' id='num_4' onClick={()=>{handdleImageClick('num_4')}}></img>
              </div>
              <div className='st-forth-row'>
              <img src="https://images.geekster.in/placed/Prasang-Chouksey.webp" alt='images' className='profile-img' id='num_5' onClick={()=>{handdleImageClick('num_5')}}></img>
              </div>
          </div>
          <div className='prev-btn' onClick={()=>{handleClickOnNextPrevButton('prev')}}>
          <img src="https://geekster.in/images/swiper-left.svg" alt='prev-data'/>
          </div>
          
          <div className='card'>
        
              <div className='profile-container'>
                <img src={currentUser.img} alt='candidate-img' className='profile-pic'></img>
                <p>{currentUser.name}</p>
                <img src={currentUser.company} alt='comp-logo' className='comp-logo'></img>
              </div>
              <div className='profile-data-container'>
                <div className='social-media'>
                  <a href='https://www.youtube.com/c/Geeksterin' rel="noreferrer" target="_blank"><img src='https://geekster.in/icons/youtube.svg' alt='sm-icon'></img><span>Watch Testimonials</span></a>
                </div>
                <div className='description'>
                <dd>{currentUser.about}
                 </dd>
                </div>
                <p className='read-more'>Read More</p>
              </div>
          </div>
          <div className='next-btn' onClick={()=>{handleClickOnNextPrevButton('next')}}>
          <img src="https://geekster.in/images/swiper-right.svg" alt='next-data'/>
          </div>
          <div className='student-right'>
              <div className='st-first-row'>
              <img src={Sdata[6].img} alt='images' className='profile-img' id='num_6' onClick={()=>{handdleImageClick('num_6')}}></img>
              </div>
              <div className='st-second-row'>
              <img src="https://images.geekster.in/placed/Karan-Kishore-Bairagi.webp" alt='images' className='profile-img' id='num_7' onClick={()=>{handdleImageClick('num_7')}}></img>
              <img src="https://images.geekster.in/placed/JALAL-UDDIN-SK.webp" alt='images' className='profile-img' id='num_8' onClick={()=>{handdleImageClick('num_8')}}></img>
              </div>
              <div className='st-third-row'>
              <img src="https://images.geekster.in/placed/Chetan.webp" alt='images' className='profile-img' id='num_9' onClick={()=>{handdleImageClick('num_9')}}></img>
              </div>
              <div className='st-forth-row'>
              <img src="https://images.geekster.in/placed/Amanpreet-Singh.webp" alt='images' className='profile-img' id='num_10' onClick={()=>{handdleImageClick('num_10')}}></img>
              </div>
          </div>
          <div className='rm-testimonial-btn'>
          <button className='More-Testimonial-btn'>Read More Testimonials</button>
          </div>
        </section>

    </>
  )
}

export default Testimonials